export const blockInvalidNumberKeys = (e: React.KeyboardEvent<HTMLInputElement>) : void => {
    if (["-", "e", "E", "+"].includes(e.key)) {
        e.preventDefault();
    }
};